import { combineReducers, configureStore } from "@reduxjs/toolkit";
import popupReducer from "./reducers/PopupSlice";
import mallReducer from "./reducers/MallSlice";
import userReducer from "./reducers/UserSlice";

const rootReducer = combineReducers({
  popupReducer,
  mallReducer,
  userReducer,
});

export const makeStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat(),
    devTools: process.env.REACT_APP_MODE !== "production",
  });
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
